<template>
  <div class="share_guide" v-show="show">
    <div>
      <span>分享后即刻下载</span>
      <img src="../../../assets/images/share_guide_img.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: 'share-guide-mask',
  props: ['bizId', 'activeId'],
  data () {
    return {
      show: false
    }
  }
}
</script>

<style lang="scss" scoped>
.share_guide{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(000,000,000, 0.5);
  z-index: 9;
  text-align: right;
  font-size:13px;
  color:rgba(255,255,255,1);
  img{
    width: 72px;
    height: 144px;
    margin-right: 18.5px;
  }
  .test-share-finish{
    margin-top: 40px;
    text-align: center;
    button{
      border: 1px solid #fff;
      background-color: transparent;
      color: #fff;
      width: 120px;
      height: 40px;
      border-radius: 8px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/solutions/template/share_guide.vue